// Build a YYYY-MM-DD string from a Date using LOCAL calendar fields.
// Never use toISOString() here — it converts to UTC and rolls the date back
// a day during Irish Summer Time (UTC+1), producing off-by-one weekdays.
function toLocalIso(dt) {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function mondayOf(d = new Date()) {
  const dt = new Date(d);
  const day = (dt.getDay() + 6) % 7; // Mon=0
  dt.setDate(dt.getDate() - day);
  return toLocalIso(dt);
}

export function weekDays(mondayIso) {
  const base = new Date(mondayIso + "T00:00:00");
  const labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  return labels.map((label, i) => {
    const d = new Date(base);
    d.setDate(base.getDate() + i);
    return { label, iso: toLocalIso(d), dom: d.getDate() };
  });
}

export function shiftWeek(mondayIso, delta) {
  const d = new Date(mondayIso + "T00:00:00");
  d.setDate(d.getDate() + delta * 7);
  return toLocalIso(d);
}
